export class QtdAtendimentos {
  qtdEmAtendimento = 0;
  qtdFilaEspera = 0;
  qtdAtendimentosHoje = 0;
  qtdAtendimentoBot = 0;
  retencaoBot = 0;

  tempoMedioAtendimentoDiario = 0;
  tempoMedioAtendimentoMensal = 0;
  tempoMedioRespostaDiario = 0;
  tempoMedioRespostaMensal = 0;
  tempoMedioAtendimentoEquipe = 0;

  qtdAtendimentoMensal = 0;
  tempoMedioFilaEspera = 0;
}
